import React from "react"
import {Search} from "components/front/Search/Search"

export const SearchRoute = () => {
  return <div className="search-route-container">
    <Search />
  </div>

}